import * as angular from "angular";
import {IController} from "angular";

export class OrganizationsTableCtrl implements IController {
  organizations: any;
  onDeleteOrganization: Function;

  constructor() {
  }
}

angular
  .module('bringoz.admin.organizations')
  .component('organizationsTable', {
    bindings: {
      organizations: '<',
      onDeleteOrganization: '&'
    },
    template: require('./organizations-table.html').default,
    controller: OrganizationsTableCtrl
  });
